import { colors } from "@areahub/theme";

/**
 *  Colors determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Tornado/FeatureServer/1&source=sd)
 *  */
const TORNADO_STOPS = [
  -9999,
  colors.blueGray[200],
  0,
  colors.green[300],
  0.038,
  colors.amber[300],
  0.134,
  colors.orange[500],
  0.318,
  colors.red[500],
  0.69,
  colors.red[600],
];

/**
 *  Legend determined from [here](https://www.arcgis.com/home/webmap/viewer.html?url=https://services.arcgis.com/XG15cJAlne2vxtgt/ArcGIS/rest/services/National_Risk_Index_Annualized_Frequency_Tornado/FeatureServer/1&source=sd)
 */
const getLegendRows = () => {
  return [
    ["> 0.69 – 2.5", 11],
    ["> 0.318 – 0.69", 9],
    ["> 0.134 – 0.318", 7],
    ["> 0.038 – 0.134", 5],
    ["0 – 0.038", 3],
    ["Not Applicable", 1],
  ].map((row) => ({
    icon: "draw-polygon",
    label: row[0] === "Not Applicable" ? row[0] : row[0] + " events/yr",
    color: TORNADO_STOPS[row[1] as number],
  }));
};

export const tornadoes = {
  stops: TORNADO_STOPS,
  props: getLegendRows(),
};
